function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f89d41a9-6aed-4006-b939-c4f0bb29339a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "fd50b82f-b596-4911-ab38-58485e303214",
    "data-name": "Wave-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "adb3d2c4-04e3-48c4-a62f-fb95c8a17c40",
    "data-name": "Rectangle",
    d: "M0,0C623,0,667,56.798,1366,45.63724V48H0Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave1;